<template>
  <transition name="el-fade-in-linear">
    <div class="upload-container">
      <div class="image-group">
        <template v-for="(img, i) in images">
          <div
            v-if="isMulti && images.length > 0"
            class="image-container"
            :key="img"
            :style="uploadStyle"
          >
            <img class="image" :src="getDownLoadUrl(img)" @click="checkImage(img)">
            <span class="el-icon-error" @click="deleteImage(i)"></span>
          </div>
        </template>
        <el-upload
          class="avatar-uploader"
          :action="uploadUrl"
          :show-file-list="false"
          :http-request="uploadFile"
          :before-upload="beforeAvatarUpload"
          :headers="headers"
          name="image"
          :data="{type: 'SYSTEM'}"
        >
          <img
            v-if="!isMulti && images"
            :src="getDownLoadUrl(images)"
            class="avatar"
            :style="uploadStyle"
          >
          <i v-else class="el-icon-plus avatar-uploader-icon" :style="uploadStyle"></i>
        </el-upload>
      </div>
      <div class="dialog">
        <el-dialog :visible.sync="dialogVisible">
          <img width="100%" :src="getDownLoadUrl(dialogImageUrl)" alt>
        </el-dialog>
      </div>
    </div>
  </transition>
</template>

<script>
import tokenStorage from '@/plugins/tokenStorage'
import {ossMixin} from '@/components/form/runtime/components/mixins'
export default {
  name: 'image-upload',
  props: ['images', 'isMulti', 'width', 'height', 'limit', 'type'],
  mixins: [ossMixin],
  data () {
    return {
      header: '',
      imageWidth: '100',
      imageHeight: '100',
      dialogVisible: false,
      dialogImageUrl: '',
      uploadUrl: `${process.env.UPLOAD_URL}/api/upload-image`
    }
  },
  methods: {
    uploadFile (files) {
      let file = files.file
      let key = this.getOssKey('SYSTEM', file.name)
      let url = sessionStorage.getItem('ossDownloadUrl')
      let formData = this.getUploadFormData(key, file)
      this.$axios.post(url, formData, {headers: {'Content-Type': 'multipart/form-data'}}).then(res => {
        if (res.status === 200) {
          this.handleAvatarSuccess(this.getResult(key, file.name), file)
        }
      })
    },
    // 文件上传成功
    handleAvatarSuccess (res) {
      let arr = this.images ? [...this.images] : []
      // 是否上传一张图片
      const url = res[0].result.dir
      this.isMulti ? arr.push(url) : (arr = url)
      this.$emit('update:images', arr)
      this.$emit('uploadSucess', url)
    },
    // 文件上传之前
    beforeAvatarUpload (file) {
      // 文件上传之前判断文件上传最大限制
      if (this.limit && this.images.length >= this.limit) {
        this.$message.error(`最多只能上传${this.limit}张图片`)
        return false
      }
      if (file.type !== 'image/png') {
        this.$message.error('上传图片只能是 png 格式')
        return false
      }
    },
    //  删除图片
    deleteImage (i) {
      let arr = [...this.images]
      arr.splice(i, 1)
      this.$emit('update:images', arr)
    },
    // 查看图片
    checkImage (img) {
      this.dialogImageUrl = img
      this.$nextTick(() => {
        this.dialogVisible = true
      })
    },
    getDownLoadUrl (path) {
      return path.includes('USER') ? sessionStorage.getItem('ossDownloadUrl') + path : path.includes('SYSTEM') ? sessionStorage.getItem('ossDownloadUrl') + path : path
    }
  },
  created () {
    this.headers = {
      Authorization: tokenStorage.getToken()
    }
    // 判断是否传递了width 和 height
    this.width && (this.imageWidth = this.width)
    this.height && (this.imageHeight = this.height)
  },
  computed: {
    uploadStyle () {
      return {
        height: this.imageHeight + 'px',
        width: this.imageWidth + 'px',
        'line-height': this.imageHeight + 'px'
      }
    }
  }
}
</script>

<style lang="scss" scope>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  text-align: center;
}
.avatar {
  display: block;
}

.upload-container {
  .image-group {
    width: 100%;
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    flex-wrap: wrap;

    .image-container {
      position: relative;
      margin-right: 15px;
      margin-bottom: 15px;

      .image {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        height: 100%;
        width: 100%;
      }

      .el-icon-error {
        color: red;
        position: absolute;
        top: -5px;
        right: -5px;
        font-size: 16px;
        cursor: pointer;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/system/image-upload.vue